export default __webpack_public_path__ + "static/media/aura.6889a31d.svg";